
import Vue from 'vue';
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', { staticClass: 'loading', class: { activeLoading: _vm.isLoading } }, [
    _c('div', { staticClass: 'px-5 py-3 bg-gray-800 rounded d-flex flex-column' }, [
      _c('img', { attrs: { src: '/assets/img/logo.svg', alt: 'Show Up Logo' } }),
      _c(
        'h3',
        { staticClass: 'text-3xl text-white' },
        [_c('b-spinner', { attrs: { type: 'grow', label: 'Spinning' } })],
        1,
      ),
      _c('p', [_vm._v('This could take a while, based on your connection.')]),
    ]),
  ]);
};
var staticRenderFns = [];

export default Vue.extend({
  render,
  staticRenderFns,
  data() {
    return {
      isLoading: true,
    };
  },
  methods: {
    hide() {
      this.isLoading = false;
    },
  },
});
